import React, { useState, useEffect } from 'react';
import {
    Box,
    ClickAwayListener,
    IconButton,
    InputAdornment,
    Paper,
    TextField
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ChevronDownIcon, ChevronUpIcon } from '../../icons';

const options = ['feet-inch', 'cm'];
const inchToCm = 2.54;

const useStyles = makeStyles({
    textboxContainer: {
        display: 'flex'
    },
    textbox: {
        flex: 1
    },
    dropDown: {
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        right: '-15px',
        top: '100%',
        padding: '5px 0',
        minWidth: '50px',
        zIndex: 10
    },
    dropDownElem: {
        padding: '5px 10px',
        '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.05)',
            cursor: 'pointer'
        }
    }
});

function strToNumberKind(value) {
    const parsed = parseInt(`${value}`.replace(/\D/g, ''), 10);
    return Number.isNaN(parsed) ? '' : parsed;
}

function convertInchesToUnit(value, unit) {
    if (unit === 'feet-inch') {
        return [Math.floor(value / 12), Math.round(value % 12)];
    }
    if (unit === 'cm') {
        return ['', Math.round(value * inchToCm)];
    }
    return ['', value];
}

const HeightTextbox = props => {
    const classes = useStyles();

    const {
        value = '',
        setValue,
        setPostfix,
        label,
        variant = 'outlined',
        // default to first element from options
        postfix = options[0] || '',
        disabledDropdown = false,
        ...otherProps
    } = props;
    const [dropdownVisible, setDropdownVisible] = useState(false);

    const [firstLabel = '', secondLabel = ''] = label
        ? postfix === 'feet-inch'
            ? [`${label} (ft)`, `in`]
            : ['', `${label} (cm)`]
        : [];

    useEffect(() => {
        if (setPostfix) {
            setPostfix('feet-inch');
        }
    }, []);

    const endAdornment = (
        <>
            {options.length > 0 && (
                <InputAdornment position="end">
                    {postfix}
                    {!disabledDropdown && (
                        <>
                            <IconButton
                                aria-label="toggle dropdown"
                                onClick={() => setDropdownVisible(!dropdownVisible)}
                            >
                                {dropdownVisible ? <ChevronUpIcon /> : <ChevronDownIcon />}
                            </IconButton>
                            {dropdownVisible && (
                                <ClickAwayListener onClickAway={() => setDropdownVisible(false)}>
                                    <Paper className={classes.dropDown}>
                                        {options.map(item => {
                                            return (
                                                <Box
                                                    key={`${item}`}
                                                    className={classes.dropDownElem}
                                                    onClick={() => {
                                                        setPostfix(item);
                                                        setDropdownVisible(!dropdownVisible);
                                                    }}
                                                >
                                                    {item}
                                                </Box>
                                            );
                                        })}
                                    </Paper>
                                </ClickAwayListener>
                            )}
                        </>
                    )}
                </InputAdornment>
            )}
        </>
    );

    const val = strToNumberKind(value);
    const [firstValue, secondValue] = val === '' ? ['', ''] : convertInchesToUnit(value, postfix);

    return (
        <div className={classes.textboxContainer}>
            {postfix === 'feet-inch' && (
                <TextField
                    {...otherProps}
                    className={classes.textbox}
                    variant={variant}
                    value={firstValue}
                    onChange={event => {
                        setValue(strToNumberKind(event.target.value) * 12 + secondValue);
                    }}
                    label={firstLabel}
                />
            )}
            <TextField
                {...otherProps}
                className={classes.textbox}
                variant={variant}
                value={secondValue}
                onChange={event => {
                    if (postfix === 'feet-inch') {
                        setValue(firstValue * 12 + strToNumberKind(event.target.value));
                    } else if (postfix === 'cm') {
                        setValue(
                            event.target.value === ''
                                ? ''
                                : strToNumberKind(event.target.value) / inchToCm
                        );
                    }
                }}
                label={secondLabel}
                InputProps={{
                    endAdornment
                }}
            />
        </div>
    );
};

export default HeightTextbox;
